// import React, { useEffect } from "react";
// import "./Footer.css";
// import { Link, useLocation } from "react-router-dom";

// const Footer = () => {
//   const { pathname } = useLocation();

//   useEffect(() => {
//     window.scrollTo({ top: 0, behavior: "auto" });
//   }, [pathname]);

//   return (
//     <>
//       <section className="footer_section">
//         <div className="Container">
//           <div className="row justify-content-center ">
//             <div className="col-lg-4 col-md-3 mb-3">
//               <img
//                 src="/assets/header/Oll-Type-Services.png"
//                 alt="Nova prime"
//                 className="footer-logo"
//               />
//               <p className="footer-description">
//                 A platform connecting customers with trusted material vendors
//                 and skilled experts nearby.
//               </p>
//               <div className="footer-social">
//                 <span className="social-icon">
//                   <img
//                     src="/assets/footer/instagram (1).png"
//                     alt="Instagram"
//                     className="social-img"
//                   />
//                 </span>
//                 <span className="social-icon">
//                   <img
//                     src="/assets/footer/facebook (1).png"
//                     alt="Facebook"
//                     className="social-img"
//                   />
//                 </span>
//               </div>
//             </div>
//             <div className="col-lg-2 col-md-3 col-sm-4 mb-3">
//               <h6 className="footer-title">Quick Links</h6>
//               <ul className="footer-list">
//                 <li><Link to="/home">Home</Link></li>
//                 <li><Link to="/contact-us">Contact Us</Link></li>
//                 <li><Link to="/about-us">About Us</Link></li>
//               </ul>
//             </div>
//             <div className="col-lg-2 col-md-3 col-sm-4 mb-3">
//               <h6 className="footer-title">Support</h6>
//               <ul className="footer-list">
//                 <li><Link to="/privacy-policy">Privacy Policy</Link></li>
//                 <li><Link to="/terms-conditions">Terms & Conditions</Link></li>
//               </ul>
//             </div>
//             <div className="col-lg-2 col-md-3 col-sm-4 mb-3">
//               <h6 className="footer-title">Get The App</h6>
//               <div className="app-buttons">
//                 <a
//                   href="https://play.google.com/store/games?device=windows"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                 >
//                   <img
//                     src="/assets/header/googleplay.png"
//                     alt="Google Play"
//                   />
//                 </a>
//                 <a
//                   href="https://play.google.com/store/apps/developer?id=Apple&hl=en"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                 >
//                   <img
//                     src="/assets/header/apple.png"
//                     alt="App Store"
//                   />
//                 </a>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default Footer;

import React, { useEffect } from "react";
import "./Footer.css";
import { Link, useLocation } from "react-router-dom";

const Footer = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname]);

  if (pathname === "/login") {
    return null;
  }

  return (
    <footer className="footer_section">
      <div className="container">
        <div className="row justify-content-between px-lg-5 ms-0 ms-0">
          <div className="col-lg-4 col-md-12 mb-4">
            <img
              src="/assets/header/nova-prime-logo.png"
              alt="Nova prime"
              className="footer-logo"
            />
            <p className="footer-description">
              A platform connecting customers with trusted material vendors and
              skilled experts nearby.
            </p>
            <div className="footer-social">
              <span className="social-icon"    onClick={() =>
                    window.open("https://www.instagram.com", "_blank")
                  }>
                <img
                  src="/assets/footer/instagram (1).png"
                  alt="Instagram"
                  className="social-img"
                
                />
              </span>
              <span className="social-icon"  onClick={() =>
                    window.open("https://www.facebook.com", "_blank")
                  }>
                 <img
                  src="/assets/footer/facebook (1).png"
                  alt="Facebook"
                  className="social-img"
                 
                  
                />
              </span>
            </div>
          </div>
          <div className="col-lg-2 col-md-3 col-sm-4  col-6 mb-4">
            <h6 className="footer-title">Quick Links</h6>
            <ul className="footer-list">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/contactus">Contact Us</Link>
              </li>
              <li>
                <Link to="/aboutus">About Us</Link>
              </li>
            </ul>
          </div>
          <div className="col-lg-2 col-md-3 col-sm-4  col-6 mb-4">
            <h6 className="footer-title">Support</h6>
            <ul className="footer-list">
              <li>
                <Link to="/privacy-policy">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/terms-conditions">Terms & Conditions</Link>
              </li>
            </ul>
          </div>
          <div className="col-lg-2 col-md-3 col-sm-4  col-6 mb-4">
            <h6 className="footer-title">Get The App</h6>
            <div className="app-buttons">
              <a
                href="https://play.google.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="/assets/About_us/Googleplay.png" alt="Google Play" />
              </a>
              <a
                href="https://apps.apple.com/in/app/apple-store"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="/assets/About_us/appstore.png" alt="App Store" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
